<template>
  <main>
    <b-container>
        <div class="page-breadcrumb">
            <router-link :to="{ name: 'ManageAccess' }"
                ><i class="fa fa-angle-left" /> Back to Manage Access</router-link
            >
        </div>

        <div class="section-header">
            <h1 class="heading">Create Realm User</h1>

            <div class="actions"></div>
        </div>

        <div class="layoutcard">
                <b-row>
                    <b-col cols="8" lg="7">
                        <b-form @submit.prevent="submit">
                        <b-row>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-username"
                                label="Username"
                                label-for="input-username"
                                >
                                <b-form-input
                                    id="input-username"
                                    v-model.trim="form.username"
                                    v-validate="{ required: true, max: 100 }"
                                    type="text"
                                    placeholder="Username"
                                    size="lg"
                                    data-vv-name="username"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-email"
                                label="Email"
                                label-for="input-email"
                                >
                                <b-form-input
                                    id="input-email"
                                    v-model.trim="form.email"
                                    v-validate="'email'"
                                    type="text"
                                    placeholder="Email"
                                    size="lg"
                                    data-vv-name="email"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-first-name"
                                label="First name"
                                label-for="input-first-name"
                                >
                                <b-form-input
                                    id="input-first-name"
                                    v-model.trim="form.firstName"
                                    v-validate="{ required: true, max: 100 }"
                                    type="text"
                                    placeholder="First name"
                                    size="lg"
                                    data-vv-name="first-name"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group
                                id="input-group-last-name"
                                label="Last name"
                                label-for="input-last-name"
                                >
                                <b-form-input
                                    id="input-last-name"
                                    v-model.trim="form.lastName"
                                    v-validate="{ required: true, max: 100 }"
                                    type="text"
                                    placeholder="Last name"
                                    size="lg"
                                    data-vv-name="last-name"
                                ></b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12">
                              <b-form-group
                                id="input-group-realm"
                                label="Realm"
                                label-for="input-realm"
                              >
                                <b-form-select
                                  v-model="form.realm"
                                  v-validate="{required: true}"
                                  :options="realmOptions"
                                  data-vv-name="realm"
                                  size="lg"
                                ></b-form-select>
                              </b-form-group>
                            </b-col>

                            <b-col cols="12">
                              <b-form-group label="User Role" v-slot="{ ariaDescribedby }">
                                <b-form-radio-group
                                  id="radio-group"
                                  v-model="form.role"
                                  :options="options"
                                  :aria-describedby="ariaDescribedby"
                                  name="radio-options"
                                ></b-form-radio-group>
                              </b-form-group>
                            </b-col>

                            <b-col class="text-right" cols="12">
                                <div class="form-footer">
                                <b-btn variant="primary" size="lg" type="submit">
                                    <i class="fa fa-plus" /> Save
                                </b-btn>
                                </div>
                            </b-col>
                        </b-row>
                        </b-form>
                    </b-col>
                </b-row>
        </div>
    </b-container>
  </main>
</template>

<script>
import { setTimeout } from "timers";
import { mapActions, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";

export default {
  name: "UserCreate",
  components: {
  },
  extends: InitAdmin,
  data() {
    return {
      form: {
        username: null,
        firstName: null,
        lastName: null,
        email: null,
        realm: null,
        temppass: null,
        role: null
      },
      options: [
        { text: 'Admin', value: 'admin' },
        { text: 'Full Access', value: 'normal' },
        { text: 'Discover Only', value: 'discover' }
      ]
    };
  },
  computed: {
    ...mapState({
      realms: (state) => state.realm.realms
    }),
    realmOptions() {
      return this.realms ? this.realms.map(realm => { return {text:realm.companyname, value:realm.companyname} }) : null;
    },
  },
  methods: {
    ...mapActions(["saveUser", "passEmail"]),
    submit() {
      this.form.temppass = this.generatePassword();
      let data = {
        username: this.form.username,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        email: this.form.email,
        realm: this.form.realm,
        temppass: this.form.temppass,
        role: this.form.role
      };

      this.saveUser({
        user: data
      }).then(res => {
        console.log(res);
        this.$toasted.show("Realm User created");
        setTimeout(() => {
          this.sendUserEmail();
          this.$router.push({ name: "ManageAccess" });
        }, 1000);
      });
    },
    sendUserEmail(){
      /*let data = {
        service_id: 'service_tlmk8lw',
        template_id: 'template_1mypwqn',
        user_id: 'S_uWT9jB0lgBTRj-m',
        template_params: {
            'username': this.form.username,
            'name': this.form.firstName + ' ' + this.form.lastName,
            'email': this.form.email,
            'url': 'https://dev.mynd-ware.com'
        }
      }*/
      let data = {
        email: this.form.email,
        name: this.form.firstName + ' ' + this.form.lastName,
        temppass: this.form.temppass,
        purpose: "newuser"
      }
      this.passEmail(data).then(() => {
        this.$toasted.show("Email sent with temp credentials to "+this.form.email, {
            type: "success",
        });
      })
    },
    generatePassword() {
      let length = 8,
          charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
          retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    }
  }
};
</script>